import { render, staticRenderFns } from "./CarisSelect.vue?vue&type=template&id=003f4321&scoped=true"
import script from "./CarisSelect.vue?vue&type=script&lang=js"
export * from "./CarisSelect.vue?vue&type=script&lang=js"
import style0 from "./CarisSelect.vue?vue&type=style&index=0&id=003f4321&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f4321",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fcaris-select%2FCarisSelect.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports